import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, RefreshCw, RotateCw } from "lucide-react";
import { api } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

const FILTERS = [
  { key: "", label: "Tutte" },
  { key: "sent", label: "Inviate" },
  { key: "failed", label: "Fallite" },
];

export default function EmailLogPanel() {
  const [filter, setFilter] = useState("");
  const [rows, setRows] = useState(null);
  const [resending, setResending] = useState(null);

  const resend = async (id) => {
    setResending(id);
    try {
      await api.post(`/super-admin/email-log/${id}/resend`);
      toast.success("Email rimandata");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reinvio non riuscito");
    } finally { setResending(null); load(filter); }
  };

  const load = (f) => {
    setRows(null);
    api.get("/super-admin/email-log", { params: f ? { status: f } : {} })
      .then(({ data }) => setRows(data))
      .catch(() => { setRows([]); toast.error("Caricamento non riuscito"); });
  };
  useEffect(() => { load(filter); }, [filter]);

  return (
    <div data-testid="email-log-panel" className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        {FILTERS.map((f) => (
          <button key={f.label} type="button" data-testid={`email-log-filter-${f.key || "all"}`} onClick={() => setFilter(f.key)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium ${filter === f.key ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
            {f.label}
          </button>
        ))}
        <Button variant="ghost" size="sm" className="ml-auto gap-1.5" data-testid="email-log-refresh-btn" onClick={() => load(filter)}>
          <RefreshCw className="w-4 h-4" /> Aggiorna
        </Button>
      </div>
      {!rows ? (
        <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>
      ) : rows.length === 0 ? (
        <p data-testid="email-log-empty" className="py-10 text-center text-sm text-slate-500">Nessuna email registrata.</p>
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-card">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
              <tr><th className="px-4 py-2">Data</th><th className="px-4 py-2">Destinatario</th><th className="px-4 py-2">Oggetto</th><th className="px-4 py-2">Esito</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`email-log-row-${r.id}`} className="border-t border-slate-100 align-top">
                  <td className="px-4 py-2 whitespace-nowrap text-slate-600">{fmtDateTime(r.created_at)}</td>
                  <td className="px-4 py-2 min-w-[200px] break-words">{r.to}</td>
                  <td className="px-4 py-2">{r.subject}</td>
                  <td className="px-4 py-2">
                    {r.status === "sent"
                      ? <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">Inviata</Badge>
                      : <>
                        <Badge className="bg-red-100 text-red-800 hover:bg-red-100">{r.resent_at ? "Fallita · rimandata" : "Fallita"}</Badge>
                        <p className="text-xs text-red-700 mt-1">{r.error}</p>
                        {r.can_resend && (
                          <Button size="sm" variant="outline" className="mt-2 h-8 gap-1.5" data-testid={`email-log-resend-${r.id}`}
                            disabled={resending === r.id} onClick={() => resend(r.id)}>
                            {resending === r.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RotateCw className="w-3.5 h-3.5" />} Rimanda
                          </Button>
                        )}
                      </>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
